import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '~/.nuxt/layouts.error.1e1c42dd.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4bfffd30 from 'nuxt_plugin_plugin_4bfffd30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_74888a0a from 'nuxt_plugin_sentryserver_74888a0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_0ecf1882 from 'nuxt_plugin_sentryclient_0ecf1882' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_pluginsvuex0828f61e_25f1eb5c from 'nuxt_plugin_pluginsvuex0828f61e_25f1eb5c' // Source: ./plugins.vuex.0828f61e.js (mode: 'all')
import nuxt_plugin_pluginsseometa6d74a5f6_7f847be2 from 'nuxt_plugin_pluginsseometa6d74a5f6_7f847be2' // Source: ./plugins.seo-meta.6d74a5f6.js (mode: 'all')
import nuxt_plugin_pluginclient_31dfb0ac from 'nuxt_plugin_pluginclient_31dfb0ac' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_d0cdbb98 from 'nuxt_plugin_pluginserver_d0cdbb98' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_workbox_3374283c from 'nuxt_plugin_workbox_3374283c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_48ee30f5 from 'nuxt_plugin_metaplugin_48ee30f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_4d95d669 from 'nuxt_plugin_iconplugin_4d95d669' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_pluginspwa484f2f11_040f8674 from 'nuxt_plugin_pluginspwa484f2f11_040f8674' // Source: ./plugins.pwa.484f2f11.js (mode: 'all')
import nuxt_plugin_pluginsdevice30d450cd_ceddd62e from 'nuxt_plugin_pluginsdevice30d450cd_ceddd62e' // Source: ./plugins.device.30d450cd.js (mode: 'all')
import nuxt_plugin_pluginstenant7e37140e_bb908b88 from 'nuxt_plugin_pluginstenant7e37140e_bb908b88' // Source: ./plugins.tenant.7e37140e.js (mode: 'all')
import nuxt_plugin_pluginshelpers229ac9e6_7926570c from 'nuxt_plugin_pluginshelpers229ac9e6_7926570c' // Source: ./plugins.helpers.229ac9e6.js (mode: 'all')
import nuxt_plugin_pluginsvessel102140ed_066ba239 from 'nuxt_plugin_pluginsvessel102140ed_066ba239' // Source: ./plugins.vessel.102140ed.js (mode: 'all')
import nuxt_plugin_pluginsrest0dc8858f_7d11079c from 'nuxt_plugin_pluginsrest0dc8858f_7d11079c' // Source: ./plugins.rest.0dc8858f.js (mode: 'all')
import nuxt_plugin_pluginsapollo7e0a3bb4_45020aea from 'nuxt_plugin_pluginsapollo7e0a3bb4_45020aea' // Source: ./plugins.apollo.7e0a3bb4.js (mode: 'all')
import nuxt_plugin_pluginutils_69c7d2b5 from 'nuxt_plugin_pluginutils_69c7d2b5' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_65c2f280 from 'nuxt_plugin_pluginrouting_65c2f280' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6515dcaf from 'nuxt_plugin_pluginmain_6515dcaf' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_intersectionobserver_0db7f058 from 'nuxt_plugin_intersectionobserver_0db7f058' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_pluginsfacebookchat6304f284_15e8c2a8 from 'nuxt_plugin_pluginsfacebookchat6304f284_15e8c2a8' // Source: ./plugins.facebook-chat.6304f284.js (mode: 'all')
import nuxt_plugin_middlewareoldbrowseref9fd2d6_e1d17634 from 'nuxt_plugin_middlewareoldbrowseref9fd2d6_e1d17634' // Source: ./middleware.old-browser.ef9fd2d6.js (mode: 'all')
import nuxt_plugin_middlewareseometacac8e1fc_9af2130e from 'nuxt_plugin_middlewareseometacac8e1fc_9af2130e' // Source: ./middleware.seo-meta.cac8e1fc.js (mode: 'all')
import nuxt_plugin_middlewareapolloreset255f9026_1d1fad42 from 'nuxt_plugin_middlewareapolloreset255f9026_1d1fad42' // Source: ./middleware.apollo-reset.255f9026.js (mode: 'all')
import nuxt_plugin_pluginscontact55e695c3_f609598e from 'nuxt_plugin_pluginscontact55e695c3_f609598e' // Source: ./plugins.contact.55e695c3.js (mode: 'all')
import nuxt_plugin_pluginscontent5d54faca_7577cfa8 from 'nuxt_plugin_pluginscontent5d54faca_7577cfa8' // Source: ./plugins.content.5d54faca.js (mode: 'all')
import nuxt_plugin_pluginsi18n34a5d2a6_4e8b1be2 from 'nuxt_plugin_pluginsi18n34a5d2a6_4e8b1be2' // Source: ./plugins.i18n.34a5d2a6.js (mode: 'all')
import nuxt_plugin_pluginstrack0ae38090_1fa59573 from 'nuxt_plugin_pluginstrack0ae38090_1fa59573' // Source: ./plugins.track.0ae38090.js (mode: 'all')
import nuxt_plugin_pluginsfacebookc4af29f6_0d84add6 from 'nuxt_plugin_pluginsfacebookc4af29f6_0d84add6' // Source: ./plugins.facebook.c4af29f6.js (mode: 'all')
import nuxt_plugin_pluginsgtag1f183250_e8bccd8e from 'nuxt_plugin_pluginsgtag1f183250_e8bccd8e' // Source: ./plugins.gtag.1f183250.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"hid":"charset","charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":"Μεταχειρισμένα Τρακτέρ και Παρελκόμενα"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"shortcut icon","href":"\u002Ffavicon.png"},{"hid":"gf-preconnect","rel":"preconnect","crossorigin":"","href":"https:\u002F\u002Ffonts.gstatic.com"},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap"},{"hid":"gf-style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap","rel":"stylesheet"},{"hid":"statica-cdn","rel":"preconnect","href":"https:\u002F\u002Fcdn.statica.eu"}],"style":[],"script":[],"title":"Παούρης Τρακτέρ","noscript":[{"innerHTML":"This website requires JavaScript."}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4bfffd30 === 'function') {
    await nuxt_plugin_plugin_4bfffd30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_74888a0a === 'function') {
    await nuxt_plugin_sentryserver_74888a0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_0ecf1882 === 'function') {
    await nuxt_plugin_sentryclient_0ecf1882(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsvuex0828f61e_25f1eb5c === 'function') {
    await nuxt_plugin_pluginsvuex0828f61e_25f1eb5c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsseometa6d74a5f6_7f847be2 === 'function') {
    await nuxt_plugin_pluginsseometa6d74a5f6_7f847be2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_31dfb0ac === 'function') {
    await nuxt_plugin_pluginclient_31dfb0ac(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_d0cdbb98 === 'function') {
    await nuxt_plugin_pluginserver_d0cdbb98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3374283c === 'function') {
    await nuxt_plugin_workbox_3374283c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_48ee30f5 === 'function') {
    await nuxt_plugin_metaplugin_48ee30f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_4d95d669 === 'function') {
    await nuxt_plugin_iconplugin_4d95d669(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginspwa484f2f11_040f8674 === 'function') {
    await nuxt_plugin_pluginspwa484f2f11_040f8674(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdevice30d450cd_ceddd62e === 'function') {
    await nuxt_plugin_pluginsdevice30d450cd_ceddd62e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginstenant7e37140e_bb908b88 === 'function') {
    await nuxt_plugin_pluginstenant7e37140e_bb908b88(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginshelpers229ac9e6_7926570c === 'function') {
    await nuxt_plugin_pluginshelpers229ac9e6_7926570c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsvessel102140ed_066ba239 === 'function') {
    await nuxt_plugin_pluginsvessel102140ed_066ba239(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsrest0dc8858f_7d11079c === 'function') {
    await nuxt_plugin_pluginsrest0dc8858f_7d11079c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsapollo7e0a3bb4_45020aea === 'function') {
    await nuxt_plugin_pluginsapollo7e0a3bb4_45020aea(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_69c7d2b5 === 'function') {
    await nuxt_plugin_pluginutils_69c7d2b5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_65c2f280 === 'function') {
    await nuxt_plugin_pluginrouting_65c2f280(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6515dcaf === 'function') {
    await nuxt_plugin_pluginmain_6515dcaf(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_0db7f058 === 'function') {
    await nuxt_plugin_intersectionobserver_0db7f058(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfacebookchat6304f284_15e8c2a8 === 'function') {
    await nuxt_plugin_pluginsfacebookchat6304f284_15e8c2a8(app.context, inject)
  }

  if (typeof nuxt_plugin_middlewareoldbrowseref9fd2d6_e1d17634 === 'function') {
    await nuxt_plugin_middlewareoldbrowseref9fd2d6_e1d17634(app.context, inject)
  }

  if (typeof nuxt_plugin_middlewareseometacac8e1fc_9af2130e === 'function') {
    await nuxt_plugin_middlewareseometacac8e1fc_9af2130e(app.context, inject)
  }

  if (typeof nuxt_plugin_middlewareapolloreset255f9026_1d1fad42 === 'function') {
    await nuxt_plugin_middlewareapolloreset255f9026_1d1fad42(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontact55e695c3_f609598e === 'function') {
    await nuxt_plugin_pluginscontact55e695c3_f609598e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontent5d54faca_7577cfa8 === 'function') {
    await nuxt_plugin_pluginscontent5d54faca_7577cfa8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18n34a5d2a6_4e8b1be2 === 'function') {
    await nuxt_plugin_pluginsi18n34a5d2a6_4e8b1be2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginstrack0ae38090_1fa59573 === 'function') {
    await nuxt_plugin_pluginstrack0ae38090_1fa59573(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfacebookc4af29f6_0d84add6 === 'function') {
    await nuxt_plugin_pluginsfacebookc4af29f6_0d84add6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsgtag1f183250_e8bccd8e === 'function') {
    await nuxt_plugin_pluginsgtag1f183250_e8bccd8e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
